import React from "react";
import { Container, Card, Button } from "react-bootstrap";
import { CheckCircle } from "react-bootstrap-icons";
import { useEffect } from "react";

const DonationSuccess = () => {
  useEffect(() => {
    document.title = "Donation Successful | Thank You!";
  }, []);

  return (
    <Container className="d-flex justify-content-center align-items-center vh-100">
      <Card className="text-center shadow-lg p-4" style={{ maxWidth: "500px" }}>
        <CheckCircle size={80} className="text-success mb-3" />
        <Card.Body>
          <Card.Title className="fw-bold fs-4">
            Thank You for Your Donation!
          </Card.Title>
          <Card.Text className="text-muted">
            Your generosity is making a difference. We truly appreciate your
            support!
          </Card.Text>
          <Button variant="primary" href="/" className="mt-3">
            Continue Browsing
          </Button>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default DonationSuccess;
